const BASE_URL = {
  BASE_URL: process.env.REACT_APP_API_URL,
};
export default BASE_URL;
